const config = {
  backgroundSrc: require('./images/nagraniaBackground.webp'),
  //**Style zmieniające komponenty z PsMusic */
  customStyles: {
    /*style do MusicList*/
    musicListComponentStyle: {
      musicList: {
        opacity: '1',
        top: '46.2%',
        left: '4.1%',
        width: '19.2%',
        fontFamily: 'Linotype',
        // boxShadow: '0px 0px 16px 1px rgba(0,0,0,.5)',
      },
      headerInput: {
        fontSize: '1.41rem',
        paddingLeft: '16px',
        letterSpacing: '0.8px',
      },
      ul: {
        maxHeight: '480px',
      },
      list: {
        boxShadow: '0px 0px 16px 1px rgba(0,0,0,.5)',
      },
      textBox: {
        fontFamily: 'Linotype',
        fontSize: '1.41rem',
      },
    },
    //**style do mini listy piosenek przy unitach */
    miniMusicListComponentStyle: {
      musicList: {
        zIndex: 1,
        opacity: '1',
        top: '32.2%',
        left: '74.1%',
        width: '19.2%',
        fontFamily: 'Linotype',
      },
      disableHeader: true,
      headerInput: {
        fontSize: '1.41rem',
        paddingLeft: '16px',
        letterSpacing: '0.8px',
      },
      ul: {
        maxHeight: '440px',
      },
      textBox: {
        fontFamily: 'Linotype',
        fontSize: '1.41rem',
      },
    },
    //**style do mini odtwarzacza przy unitach */
    miniMusicPlayerComponentStyle: {
      musicPlayer: {
        top: '71%',
        left: '75.5%',
        height: '10%',
        width: '20%',
        zIndex: 11,
      },
      disableBackground: true,
      title: {
        width: '100%',
      },
    },
    /*style do MusicFilter*/
    musicFilterComponent: {
      musicFilter: {
        opacity: '1',
        top: '18.5%',
        left: '4.1%',
        width: '19.2%',
        fontFamily: 'Linotype',
      },
    },
  },

  //**Status filtrów - uwaga trzeba je zadeklarować, inaczej filtry się nie zainicjują */
  //** Filtry można pogrupować, filtry w tej samej grupie będą się wykluczać, jeśli zaznaczy się cd1 to nie pojawią się elementy z cd2 */
  filtersStatus: [
    // { name: 'CD1', group: 'plyta', active: false },
    // { name: 'CD2', group: 'plyta', active: false },
    { name: 'CD1', active: false },
    { name: 'Routine recordings', active: false },
    { name: 'Songs', active: false },
    { name: 'Rhymes', active: false },
    { name: 'Stories', active: false },
    // { name: 'Listening exercises', active: false },
    { name: 'Picture Dictionary', active: false },
  ],

  //** Podstawowa deklaracja filtrów - flata type oznacza czy filtry mają się pozycjonować w poziomie czy pionie */
  filters: [
    // {
    //   type: 'multi',
    //   filters: [{ name: 'CD1' }, { name: 'CD2' }],
    // },
    {
      type: 'single',
      name: 'CD1',
    },
    {
      type: 'single',
      name: 'Routine recordings',
    },
    {
      type: 'single',
      name: 'Songs',
    },
    {
      type: 'single',
      name: 'Rhymes',
    },
    {
      type: 'single',
      name: 'Stories',
    },
    // {
    //   type: 'single',
    //   name: 'Listening exercises',
    // },
    {
      type: 'single',
      name: 'Picture Dictionary',
    },
  ],
  //** Deklaracja piosenek, ścieżki trzeba dać z require */
  songsFestival: [
    {
      path: 'musics/cd1/Track_37_Baubles_Bells.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Festivals – Christmas'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `37 Baubles, Bells and Stars`,
      name: `37 Baubles, Bells and Stars`,
    },
    {
      path: 'musics/cd1/Track_38_Carnival_Dance.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Festivals – Carnival'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `38 My Pizza`,
      name: `38 My Pizza`,
    },
    {
      path: 'musics/cd1/Track_39_My_Pizza.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Festivals – Pizza Day'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `39 Carnival Dance`,
      name: `39 Carnival Dance`,
    },
    {
      path: 'musics/cd1/Track_40_Easter_Is_Fun.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Festivals – Easter'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `40 Easter Is Fun`,
      name: `40 Easter Is Fun`,
    },
    // {
    //   path: 'musics/cd2/22_2.22 Christmas Counting.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'Festivals - Christmas'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.22 Christmas Counting`,
    //   name: `2.22 Christmas Counting`,
    // },
    // {
    //   path: 'musics/cd2/23_2.23 Where_s the Pot of Gold.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', "Festivals - St. Patrick's Day"],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.23 Where’s the Pot of Gold?`,
    //   name: `2.23 Where’s the Pot of Gold?`,
    // },
    // {
    //   path: 'musics/cd2/24_2.24 Easter Freeze.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'Festivals - Easter'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.24 Easter Freeze`,
    //   name: `2.24 Easter Freeze`,
    // },
    // {
    //   path: 'musics/cd2/25_2.25 Happy Family.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'Festivals - Family day'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.25 Happy Family`,
    //   name: `2.25 Happy Family`,
    // },
  ],
  songs: [
    {
      path: 'musics/cd1/Track_1_Fun Time.mp3',
      secondPath: '',
      tags: ['CD1'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `1 Fun time`,
      name: `1 Fun time`,
    },
    {
      path: 'musics/cd1/Track_2_Hello_.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Routine recordings', 'u1', 'u2', 'u3', 'u4', 'u5', 'u6', 'u7', 'u8', 'u9', 'u10'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `2 Hello!`,
      name: `2 Hello!`,
    },
    {
      path: 'musics/cd1/Track_3_Bye-bye Song.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Routine recordings', 'u1', 'u2', 'u3', 'u4', 'u5', 'u6', 'u7', 'u8', 'u9', 'u10'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `3 Bye-bye Song`,
      name: `3 Bye-bye Song`,
    },
    {
      path: 'musics/cd1/Track_4_Fun Time Rhyme.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'Routine recordings', 'u1', 'u2', 'u3', 'u4', 'u5', 'u6', 'u7', 'u8', 'u9', 'u10'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `4 Fun Time Rhyme`,
      name: `4 Fun Time Rhyme`,
    },
    {
      path: 'musics/cd1/Track_5_Table Time Rhyme.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'Routine recordings', 'u1', 'u2', 'u3', 'u4', 'u5', 'u6', 'u7', 'u8', 'u9', 'u10'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `5 Table Time Rhyme`,
      name: `5 Table Time Rhyme`,
    },
    {
      path: 'musics/cd1/Track_6_Let_s Move_.mp3',
      secondPath: '',
      tags: ['CD1', 'Routine recordings', 'u1', 'u2', 'u3', 'u4', 'u5', 'u6', 'u7', 'u8', 'u9', 'u10'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `6 Let's Move!`,
      name: `6 Let's Move!`,
    },
    {
      path: 'musics/cd1/Track_7_I_m Dusty_.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u1'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `7 I'm Dusty!`,
      name: `7 I'm Dusty!`,
    },
    {
      path: 'musics/cd1/Track_8_Story_1_Hello Lisa_.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u1'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `8 Hello Lisa!`,
      name: `8 Hello Lisa!`,
    },
    {
      path: 'musics/cd1/Track_9_Look_.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u1'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `9 Look!`,
      name: `9 Look!`,
    },
    {
      path: 'musics/cd1/Track_10_It_s Blue_.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u2'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `10 It's Blue!`,
      name: `10 It's Blue!`,
    },
    {
      path: 'musics/cd1/Track_11_Story_2_Colours.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u2'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `11 Colours`,
      name: `11 Colours`,
    },
    {
      path: 'musics/cd1/Track_12_Yika yika.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u2'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `12 Yika, yika`,
      name: `12 Yika, yika`,
    },
    {
      path: 'musics/cd1/Track_13_My Emotions.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u3'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `13 My Emotions`,
      name: `13 My Emotions`,
    },
    {
      path: 'musics/cd1/Track_14_Story_3_I_m hungry_.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u3'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `14 I'm hungry!`,
      name: `14 I'm hungry!`,
    },
    {
      path: 'musics/cd1/Track_15_How Are You.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u3'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `15 How Are You?`,
      name: `15 How Are You?`,
    },
    {
      path: 'musics/cd1/Track_16_It_s My Mummy.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u4'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `16 It's My Mummy!`,
      name: `16 It's My Mummy!`,
    },
    {
      path: 'musics/cd1/Track_17_Story_4_Help me_.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u4'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `17 Help me!`,
      name: `17 Help me!`,
    },
    {
      path: 'musics/cd1/Track_18_Yoo-hoo.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u4'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `18 Yoo-hoo!`,
      name: `18 Yoo-hoo!`,
    },
    {
      path: 'musics/cd1/Track_19_My Toys.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u5'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `19 My Toys`,
      name: `19 My Toys`,
    },
    {
      path: 'musics/cd1/Track_20_Story_5_My cars.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u5'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `20 My Cars`,
      name: `20 My Cars`,
    },
    {
      path: 'musics/cd1/Track_21_One, Two, Three.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u5'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `21 One, Two, Three`,
      name: `21 One, Two, Three`,
    },
    {
      path: 'musics/cd1/Track_22_Clap_Clap_Clap.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u6'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `22 Clap, Clap, Clap!`,
      name: `22 Clap, Clap, Clap!`,
    },
    {
      path: 'musics/cd1/Track_23_Story_6_Talent_show.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u6'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `23 Talent Show`,
      name: `23 Talent Show`,
    },
    {
      path: 'musics/cd1/Track_24_Catch_the_Ball.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u6'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `24 Catch the Ball`,
      name: `24 Catch the Ball`,
    },
    {
      path: 'musics/cd1/Track_25_It_s_a_Pear.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u7'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `25 It's a Pear!`,
      name: `25 It's a Pear!`,
    },
    {
      path: 'musics/cd1/Track_26_Story_7_Picnic.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u7'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `26 Picnic`,
      name: `26 Picnic`,
    },
    {
      path: 'musics/cd1/Track_27_A_Pepper_Is_Green.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u7'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `27 A Pepper Is Green`,
      name: `27 A Pepper Is Green`,
    },
    {
      path: 'musics/cd1/Track_28_What_Is_It.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u8'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `28 What Is It?`,
      name: `28 What Is It?`,
    },
    {
      path: 'musics/cd1/Track_29_Story_8_I_Love_Pets.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u8'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `29 I Love Pets`,
      name: `29 I Love Pets`,
    },
    {
      path: 'musics/cd1/Track_30_Hey_Hey.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u8'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `30 Hey, Hey!`,
      name: `30 Hey, Hey!`,
    },
    {
      path: 'musics/cd1/Track_31_I_ve_Got_One_Head.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u9'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `31 I've Got One Head`,
      name: `31 I've Got One Head`,
    },
    {
      path: 'musics/cd1/Track_32_Story_9_Let_s_Dance.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u9'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `32 Let's Dance!`,
      name: `32 Let's Dance!`,
    },
    {
      path: 'musics/cd1/Track_33_Look_at_Me.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u9'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `33 Look at Me!`,
      name: `33 Look at Me!`,
    },
    {
      path: 'musics/cd1/Track_34_A_Yellow_hat.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'u10'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `34 A Yellow Hat`,
      name: `34 A Yellow Hat`,
    },
    {
      path: 'musics/cd1/Track_35_Story_10_Fashion_show.mp3',
      secondPath: '',
      tags: ['CD1', 'Stories', 'u10'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `35 Fashion Show`,
      name: `35 Fashion Show`,
    },
    {
      path: 'musics/cd1/Track_36_Yes_You.mp3',
      secondPath: '',
      tags: ['CD1', 'Rhymes', 'u10'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `36 Yes! You!`,
      name: `36 Yes! You!`,
    },
    {
      path: 'musics/cd1/Track_37_Baubles_Bells.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Festivals – Christmas'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `37 Baubles, Bells and Stars`,
      name: `37 Baubles, Bells and Stars`,
    },
    {
      path: 'musics/cd1/Track_38_Carnival_Dance.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Festivals – Carnival'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `38 My Pizza`,
      name: `38 My Pizza`,
    },
    {
      path: 'musics/cd1/Track_39_My_Pizza.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Festivals – Pizza Day'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `39 Carnival Dance`,
      name: `39 Carnival Dance`,
    },
    {
      path: 'musics/cd1/Track_40_Easter_Is_Fun.mp3',
      secondPath: '',
      tags: ['CD1', 'Songs', 'Festivals – Easter'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `40 Easter Is Fun`,
      name: `40 Easter Is Fun`,
    },
    {
      path: 'musics/cd1/Track_41_Slowniczek_Unit_1.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u1'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `41 Picture dictionary U1 `,
      name: `41 Picture dictionary U1 `,
    },
    {
      path: 'musics/cd1/Track_42_Słowniczek_Unit_2.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u2'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `42 Picture dictionary U2`,
      name: `42 Picture dictionary U2`,
    },
    {
      path: 'musics/cd1/Track_43_Slowniczek_Unit_3.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u3'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `43 Picture dictionary U3`,
      name: `43 Picture dictionary U3`,
    },
    {
      path: 'musics/cd1/Track_44_Slowniczek_Unit_4.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u4'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `44 Picture dictionary U4`,
      name: `44 Picture dictionary U4`,
    },
    {
      path: 'musics/cd1/Track_45_Slowniczek_Unit_5.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u5'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `45 Picture dictionary U5`,
      name: `45 Picture dictionary U5`,
    },
    {
      path: 'musics/cd1/Track_46_Slowniczek_Unit_6.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u6'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `46 Picture dictionary U6`,
      name: `46 Picture dictionary U6`,
    },
    {
      path: 'musics/cd1/Track_47_Slowniczek_Unit_7.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u7'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `47 Picture dictionary U7`,
      name: `47 Picture dictionary U7`,
    },
    {
      path: 'musics/cd1/Track_48_Slowniczek_Unit_8.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u8'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `48 Picture dictionary U8`,
      name: `48 Picture dictionary U8`,
    },
    {
      path: 'musics/cd1/Track_49_Slowniczek_Unit_9.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u9'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `49 Picture dictionary U9`,
      name: `49 Picture dictionary U9`,
    },
    {
      path: 'musics/cd1/Track_50_Slowniczek_Unit_10.mp3',
      secondPath: '',
      tags: ['CD1', 'Picture Dictionary', 'u10'],
      //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
      title: `50 Picture dictionary U10`,
      name: `50 Picture dictionary U10`,
    },
    // {
    //   path: 'musics/cd2/01_2.1 Fun Time BB+.mp3',
    //   secondPath: '',
    //   tags: ['CD2', ''],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.1 Fun Time BB+`,
    //   name: `2.1 Fun Time BB+`,
    // },
    // {
    //   path: 'musics/cd2/02_2.2 How Many Flowers.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'U6'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.2 How Many Flowers?`,
    //   name: `2.2 How Many Flowers?`,
    // },
    // {
    //   path: 'musics/cd2/03_2.3 Listening Unit 6.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Listening exercises', 'U6'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.3 Listening Unit 6 `,
    //   name: `2.3 Listening Unit 6 `,
    // },
    // {
    //   path: 'musics/cd2/04_2.4 Story 6. I Love Winter.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Stories', 'U6'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.4 Story 6. I Love Winter`,
    //   name: `2.4 Story 6. I Love Winter`,
    // },
    // {
    //   path: 'musics/cd2/05_2.5 Seasons.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Rhymes', 'U6'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.5 Seasons`,
    //   name: `2.5 Seasons`,
    // },
    // {
    //   path: 'musics/cd2/06_2.6 Yummy Food.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'U7'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.6 Yummy Food`,
    //   name: `2.6 Yummy Food`,
    // },
    // {
    //   path: 'musics/cd2/07_2.7 Listening Unit 7.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Listening exercises', 'U7'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.7 Listening Unit 7`,
    //   name: `2.7 Listening Unit 7`,
    // },
    // {
    //   path: 'musics/cd2/08_2.8 Story 7. My Favourite Food.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Stories', 'U7'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.8 Story 7. My Favourite Food`,
    //   name: `2.8 Story 7. My Favourite Food`,
    // },
    // {
    //   path: 'musics/cd2/09_2.9 I Like My Lunch.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Rhymes', 'U7'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.9 I Like My Lunch `,
    //   name: `2.9 I Like My Lunch `,
    // },
    // {
    //   path: 'musics/cd2/10_2.10 It Can.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'U8'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.10 It Can`,
    //   name: `2.10 It Can`,
    // },
    // {
    //   path: 'musics/cd2/11_2.11 Listening Unit 8.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Listening exercises', 'U8'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.11 Listening Unit 8`,
    //   name: `2.11 Listening Unit 8`,
    // },
    // {
    //   path: 'musics/cd2/12_2.12 Story 8. It_s a Tiger.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Stories', 'U8'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.12 Story 8. It’s a Tiger! `,
    //   name: `2.12 Story 8. It’s a Tiger! `,
    // },
    // {
    //   path: 'musics/cd2/13_2.13 Wild Animals.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Rhymes', 'U8'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.13 Wild Animals`,
    //   name: `2.13 Wild Animals`,
    // },
    // {
    //   path: 'musics/cd2/14_2.14 Can I Play.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'U9'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.14 Can I Play?`,
    //   name: `2.14 Can I Play?`,
    // },
    // {
    //   path: 'musics/cd2/15_2.15 Listening Unit 9.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Listening exercises', 'U9'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.15 Listening Unit 9`,
    //   name: `2.15 Listening Unit 9`,
    // },
    // {
    //   path: 'musics/cd2/16_2.16 Story 9. In the Playground.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Stories', 'U9'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.16 Story 9. In the Playground`,
    //   name: `2.16 Story 9. In the Playground`,
    // },
    // {
    //   path: 'musics/cd2/17_2.17 Let_s Go to the Playground.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Rhymes', 'U9'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.17 Let’s Go to the Playground`,
    //   name: `2.17 Let’s Go to the Playground`,
    // },
    // {
    //   path: 'musics/cd2/18_2.18 What Are You Wearing.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'U10'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.18 What Are You Wearing?`,
    //   name: `2.18 What Are You Wearing?`,
    // },
    // {
    //   path: 'musics/cd2/19_2.19 Listening Unit 10.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Listening exercises', 'U10'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.19 Listening Unit 10`,
    //   name: `2.19 Listening Unit 10`,
    // },
    // {
    //   path: 'musics/cd2/20_2.20 Story 10. A Big Wave.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Stories', 'U10'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.20 Story 10. A Big Wave`,
    //   name: `2.20 Story 10. A Big Wave`,
    // },
    // {
    //   path: 'musics/cd2/21_2.21 On the Beach.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Rhymes', 'U10'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.21 On the Beach`,
    //   name: `2.21 On the Beach`,
    // },
    // {
    //   path: 'musics/cd2/22_2.22 Christmas Counting.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'Festivals - Christmas'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.22 Christmas Counting`,
    //   name: `2.22 Christmas Counting`,
    // },
    // {
    //   path: 'musics/cd2/23_2.23 Where_s the Pot of Gold.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', "Festivals - St. Patrick's Day"],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.23 Where’s the Pot of Gold?`,
    //   name: `2.23 Where’s the Pot of Gold?`,
    // },
    // {
    //   path: 'musics/cd2/24_2.24 Easter Freeze.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'Festivals - Easter'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.24 Easter Freeze`,
    //   name: `2.24 Easter Freeze`,
    // },
    // {
    //   path: 'musics/cd2/25_2.25 Happy Family.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Songs', 'Festivals - Family day'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.25 Happy Family`,
    //   name: `2.25 Happy Family`,
    // },
    // {
    //   path: 'musics/cd2/26_2.26 Picture Dictionary Unit 6.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Picture Dictionary', 'U6'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.26 Picture Dictionary Unit 6`,
    //   name: `2.26 Picture Dictionary Unit 6`,
    // },
    // {
    //   path: 'musics/cd2/27_2.27 Picture Dictionary Unit 7.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Picture Dictionary', 'U7'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.27 Picture Dictionary Unit 7`,
    //   name: `2.27 Picture Dictionary Unit 7`,
    // },
    // {
    //   path: 'musics/cd2/28_2.28 Picture Dictionary Unit 8.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Picture Dictionary', 'U8'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.28 Picture Dictionary Unit 8`,
    //   name: `2.28 Picture Dictionary Unit 8`,
    // },
    // {
    //   path: 'musics/cd2/29_2.29 Picture Dictionary Unit 9.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Picture Dictionary', 'U9'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.29 Picture Dictionary Unit 9`,
    //   name: `2.29 Picture Dictionary Unit 9`,
    // },
    // {
    //   path: 'musics/cd2/30_2.30 Picture Dictionary Unit 10.mp3',
    //   secondPath: '',
    //   tags: ['CD2', 'Picture Dictionary', 'U10'],
    //   //   backgroundText: '@/config/elements/audioBcg/ID0160.jpg',
    //   title: `2.30 Picture Dictionary Unit 10`,
    //   name: `2.30 Picture Dictionary Unit 10`,
    // },
  ],
};

export default config;
